import React from "react";
import * as storeService from "../addRuleStoreService";
import { connect } from "react-redux";

function AddRuleInputField({ label, ruleKey, rule, disabled, placeholder = '' }) {

    const onChange = (value) => {
        storeService.changeRule({ ...rule, [ruleKey]: value })
    }

    return (
        <div className="addrules-form-group-v2">
            <label className="addrules-form-label-v2">{label}</label>
            <input
                className="addrules-form-input-v2"
                value={rule[ruleKey] || ''}
                placeholder={placeholder}
                disabled={disabled}
                onChange={disabled ? null : event => onChange(event.target.value)}
            />
        </div>
    )

}

function mapStateToProps(state) {

    return {
        rule: state.addRulesPage.rule || {}
    }

}

export default connect(mapStateToProps)(AddRuleInputField);
